import { render, staticRenderFns } from "./EmptyWebhookView.vue?vue&type=template&id=381829b9&"
import script from "./EmptyWebhookView.vue?vue&type=script&lang=js&"
export * from "./EmptyWebhookView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports